let school;
const pref_loc_data = {};
let location_type = 'CURRENT';
let justSubmitted = false;
let initialLocation = {lat: latitude, lng: longitude, city: cityName};
let searchedCity;

if (typeof pageType === 'undefined') pageType = '';

let prefSearchTextInputField = $('#prefSearchTextField');
let prefSearchLatitude = $('#prefLoclat');
let prefSearchLongitude = $('#prefLoclng');
let userLocationLatitude = $('#userLocPref');
let userLocationLongitude = $('#userLongPref');
let preferredLocationModal = $('#preferredLocationModal');


window.getPrefLoc = () => {
    if (user) {
        dashboardApiAxios.get(`${APP_BASE_URL}/users/user_track/user_track_get.php`)
            .then(response => {
                if (response) {
                    prefSearchTextInputField.val(pref_loc_data.place_name);
                    location_type = pref_loc_data.location_type;
                    prefSearchLatitude.val(pref_loc_data.lat);
                    prefSearchLongitude.val(pref_loc_data.lng);
                    userLocationLatitude.val(pref_loc_data.lat);
                    userLocationLongitude.val(pref_loc_data.lng);
                    /*if (pref_loc_data.label) {
                        $('input[name=prefOpt][value=' + pref_loc_data.label + ']').attr('checked', 'checked');
                    }
                    if ($('input[name= ]:checked').val() === "home") {
                        $('#pref_location_text').html('Preferred location <b class="text-capitalize">' + $('input[name=prefOpt]:checked').val() + '</b>');
                    } else {
                        $('#pref_location_text').text('Preferred location ' + pref_loc_data.place_name);
                    }*/
                    // loadWishlist();
                } else {
                    refreshInitialLocation();
                    prefSearchTextInputField.val(initialLocation.city);
                    prefSearchLatitude.val(initialLocation.lat);
                    prefSearchLongitude.val(initialLocation.lng);
                    userLocationLatitude.val(pref_loc_data.lat); // used for shortlist
                    userLocationLongitude.val(pref_loc_data.lng);
                    if ((typeof (schoolType) != 'undefined' && ([3, 4, 6].includes(schoolType)) && pageType === 'UAE_DETAIL') || pageType === 'UAE_PAID_COUNSELLING') {
                        hiddenPreferredLocation();
                    } else {
                        preferredLocationModal.modal('show');
                    }
                }
            })
    }
}

window.refreshInitialLocation = () => {
    if (pref_loc_data.location_type && pref_loc_data.location_type === 'PREF') {
        initialLocation = {
            lat: pref_loc_data.lat,
            lng: pref_loc_data.lng,
            city: pref_loc_data.place_name
        }
    } else if (pageType === "UAE_SEARCH") {
        initialLocation = getAddressFromUrl();
        if (!initialLocation.city) {
            ga('send', 'event', {
                eventCategory: 'debug_api_call',
                eventAction: 'Preferred_search',
                eventLabel: 'Preferred_search'
            });
            if ($('#ip_cityname').val()) {
                ga('send', 'event', {
                    eventCategory: 'debug_api_call',
                    eventAction: 'Preferred_search_ip_city',
                    eventLabel: 'Preferred_search_ip_city'
                });
                initialLocation.city = $('#ip_cityname').val();
            } else {
                ga('send', 'event', {
                    eventCategory: 'debug_api_call',
                    eventAction: 'Preferred_search_geo_coder_city',
                    eventLabel: 'Preferred_search_geo_coder_city'
                });
                initialLocation.city = getLocationName(initialLocation);
            }
        }
    } else if (pageType && pageType === "UAE_HOME") {
        if (!initialLocation.city) {
            ga('send', 'event', {
                eventCategory: 'debug_api_call',
                eventAction: 'Preferred_home',
                eventLabel: 'Preferred_home'
            });
            initialLocation.city = getLocationName(initialLocation);
        }
    } else if (school && pageType && pageType === "UAE_DETAILS_PAGE") {
        initialLocation = {
            lat: school.slat,
            lng: school.slon,
            city: schoolAddressCity // schoolAddressCity is in detail page
        }
    } else if (school) { // other pages case
        initialLocation = {
            lat: school.slat,
            lng: school.slon,
            city: cityName
        }
    }
    if (!initialLocation.city) {
        ga('send', 'event', {
            eventCategory: 'debug_api_call',
            eventAction: 'Preferred_all_other_cases',
            eventLabel: 'Preferred_all_other_cases'
        });
        initialLocation.city = getLocationName(initialLocation);
    }
}

window.hiddenPreferredLocation = () => {
    let place_name = prefSearchTextInputField.val();
    let lat = prefSearchLatitude.val();
    let lng = prefSearchLongitude.val();
    if ((pageType === "UAE_SEARCH") || (pageType === "UAE_HOME") || school) {
        prefSearchTextInputField.val(initialLocation.city);
        location_type = location_type;
        prefSearchLatitude.val(initialLocation.lat);
        prefSearchLongitude.val(initialLocation.lng);
        submitPrefLoc();
    }
    //preSchoolCron(user.id);
}

window.submitPrefLoc = () => {
    if (justSubmitted) return;
    justSubmitted = true;
    let data = {
        place_name: prefSearchTextInputField.val(),
        location_type: location_type,
        lat: prefSearchLatitude.val(),
        lng: prefSearchLongitude.val(),
        label: $('input[name=prefOpt]:checked').val()
    };
    if (DEBUG) console.log('submitting tracking data', data);
    if (pageType && pageType === "UAE_HOME") {
        data.location_type = "CURRENT";
    } else if (pageType === "UAE_SEARCH") {
        data.location_type = "INPUT";
    }
    dashboardApiAxios.post(`${HOST}/users/user_track/user_track_insert_or_update.php`, data)
        .then((response) => {
            if (response) {
                if (DEBUG) console.log('Final submit cron waiting for call');
                preferredLocationModal.modal('hide');
                $('#pref_location_error').text('');
                getPrefLoc();
                //preSchoolCron(user.id);
            } else {
                $('#pref_location_error').text("please try again failed to set Preferred location.");
            }
        });
}

window.getAddressFromUrl = () => {
    initialLocation.lat = $('#cityLat').val();
    initialLocation.lng = $('#cityLng').val();
    initialLocation.city = $('#formatted_address').val();

    if (initialLocation.lat === '' || initialLocation === '') {
        initialLocation.lat = slat;
        initialLocation.lng = slon;
        initialLocation.city = null;
    }
    return initialLocation;
}

window.getLocationName = (initiLocation) => {
    let latlng = {lat: parseFloat(initiLocation.lat), lng: parseFloat(initiLocation.lng)};
    geocoder.geocode({'location': latlng}, function (results, status) {
        if (status === 'OK') {
            if (results[0]) {
                initiLocation.city = results[0].formatted_address;
                initialLocation.city = results[0].formatted_address;
                prefSearchTextInputField.val(initialLocation.city);
                return initiLocation.city;
            } else {
                if (DEBUG) console.log('No results found');
                if (getLocationName(initialLocation)) {
                    initialLocation.city = searchedCity;
                }
            }
        } else {
            if (DEBUG) console.log('Geocoder failed due to: ' + status);
            if (pageType === "UAE_SEARCH") {
                initialLocation.city = searchedCity;
            }
        }
    });
}



$('#prefLocForm').on('submit', (e) => {
    e.preventDefault();
    justSubmitted = false;
    location_type = 'PREF';

    /* Todo - add form validations */

    submitPrefLoc();
});
